import styled from 'styled-components';

export const TopBarWrap = styled.div`
  display: flex;
  align-items: center;
  margin-left: 24px;
  justify-content: flex-start;
`;

export const TopBarTitle = styled.div`
  ${({ theme }) => theme.textStyles.heading01global04};
  margin-top: 18px;
  margin-bottom: 0px;
`;

export const Logo = styled.img`
  margin-right: 8px;
  width: 40px;
  height: 40px;
`;

export const SideBarWrap = styled.div`
  min-width: 250px;
  top: 0;
  left: 0;
  background-color: ${({ theme }) => theme.palette.neutral01};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  -webkit-box-shadow: -2px 0px 14px -6px rgba(0, 0, 0, 0.45);
  -moz-box-shadow: -2px 0px 14px -6px rgba(0, 0, 0, 0.45);
  box-shadow: -2px 0px 14px -6px rgba(0, 0, 0, 0.45);
  z-index: 99;
`;

export const ButtonWrap = styled.div`
  margin: 24px;
`;



// WEBPACK FOOTER //
// /opt/build/repo/src/modules/main/components/SideBar/SideBar.styled.js